import React from "react";
import upcomingEvents from "../data/UpcomingEvents";
import upcomingEventsMessage from "../data/UpcomingEventsMessage";

function UpcomingEvents() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const activeEvents = upcomingEvents
    .filter((event) => {
      const endDate = new Date(`${event.endDate}T23:59:59`);
      return endDate >= today;
    })
    .sort((a, b) => {
      const firstDate = new Date(`${a.startDate}T00:00:00`);
      const secondDate = new Date(`${b.startDate}T00:00:00`);

      return firstDate - secondDate;
    });

  return (
    <section className="upcoming-events" id="upcoming-events">
      <div className="container">
        <h2 className="upcoming-events-title futuraPTMedium">
          Upcoming Events
        </h2>

        {upcomingEventsMessage.enabled ? (

    <div className="upcoming-events-message">

        <h2 className="futuraPTMedium">
            {upcomingEventsMessage.title}
        </h2>

        <h5 className="futuraPTBook">
            {upcomingEventsMessage.message}
        </h5>

    </div>

) : activeEvents.length > 0 ? (

    <div className="row g-4">

        {activeEvents.map((event) => (

            <div
                className="col-12 col-md-6 col-xl-4 justify-content-center"
                key={event.id}
            >
                <a
                    href={event.link}
                    className="card event-card mx-auto"
                    style={{
                        backgroundImage: `url("${event.image}")`
                    }}
                >
                    <div className="card-body">

                        <h3 className="event-card-title futuraPTBold">
                            {event.title}
                        </h3>

                        {event.subtitle && (
                            <div className="event-card-subtitle futuraPTMedium">
                                {event.subtitle}
                            </div>
                        )}

                        <div className="event-card-date futuraPTMedium">
                            {event.date}
                        </div>

                    </div>
                </a>
            </div>

        ))}

    </div>

) : (

    <div className="no-events-message">

        <h3 className="futuraPTMedium">
            No Upcoming Events
        </h3>

        <p className="futuraPTBook">
            We're currently scheduling our next round of events. Check back soon for new dates and announcements.
        </p>

    </div>

)}
      </div>
    </section>
  );
}

export default UpcomingEvents;